import React from "react"
import ContactSection from "../shared/contact"
import styled from "styled-components"
import Typography from "./typography.styles"
import Breakpoints from "./breakpoints"

export const LightboxWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 1000;
`

export const LightboxControls = styled.div`
  width: calc(100% - 2 * 16px);
  background-color: #000000;
  opacity: 0.85;
  display: flex;
  align-items: center;
  padding: 16px;
  justify-content: flex-end;

  & > button {
    ${Typography.mobileTextStyles.MobileHeadingFourRegular}
    color: #fff;
    border: 1px solid white;
    padding: 8px 16px;
    background-color: #ffffff00;
  }
`

export const LightboxContentWrapper = styled.div`
  padding: 0 10vw;
  display: flex;
  overflow: scroll;
  width: calc(100% - 20vw);
  height: calc(100vh - 75px);

  @media (min-width: ${Breakpoints.md}) {
    padding: 0 5vw;
    width: calc(100% - 10vw);
  }
`

export const Lightbox = ({ children, toggle, index = 0 }) => {
  return (
    <LightboxWrapper>
      <LightboxControls>
        <button onClick={toggle}>Close</button>
      </LightboxControls>
      <LightboxContentWrapper>
        <ContactSection />
      </LightboxContentWrapper>
    </LightboxWrapper>
  )
}

export default Lightbox
